// Wraper para o Local Storage, Wraper feito para impedir o safari matar a aplicação ao acessar o storage
let _storageIsEnable = true;

try {
  typeof window.localStorage;
} catch(err) {
  _storageIsEnable = false;
  console.error('FcmLocalStorage: Navegador obsoleto ou com os cookies desabilitados, atualize o navegador e ou habilite os cookies', err.message);
}

class _FcmLocalStorage {

  *[Symbol.iterator]() {
    if(_storageIsEnable) {
      return window.localStorage[Symbol.iterator]();
    }
  }
  key(...args) {
    if(_storageIsEnable) {
      return window.localStorage.key(...args);
    }
    return null;
  }
  removeItem(...args) {
    if(_storageIsEnable) {
      return window.localStorage.removeItem(...args);
    }
  }
  setItem(...args) {
    if(_storageIsEnable) {
      return window.localStorage.setItem(...args);
    }
  }
  getItem(...args) {
    if(_storageIsEnable) {
      return window.localStorage.getItem(...args);
    }
    return null;
  }
  clear() {
    if(_storageIsEnable) {
      return window.localStorage.clear();
    }
  }
  get length() {
    if(_storageIsEnable) {
      return window.localStorage.length;
    }
    return 0;
  }


  getObj(key) {
    if(_storageIsEnable) {
      try {
        return JSON.parse(window.localStorage.getItem(key) || null);
      } catch(err) {
        return window.localStorage.getItem(key) || null;
      }
    }
    return null;
  }
  setObj(key, obj) {
    if(_storageIsEnable) {
      window.localStorage.setItem(key, JSON.stringify(obj, function(k, v) {
        if (typeof v === 'object' && v && (v.wa === 'FieldValue.serverTimestamp' || v.fa === 'FieldValue.serverTimestamp') || k === 'updatedAt') {
          return null;
        }
        return v;
      }));
    }
  }
  storageIsEnable() {
    return _storageIsEnable;
  }
  /**
   * Remove todas as chaves que começam com `prefix`. Coleta antes de remover: remover durante a
   * varredura por índice desloca as chaves seguintes, e a cada remoção uma chave era pulada.
   * @param {String} prefix
   * @returns {Number} quantidade de chaves removidas
   */
  removeByPrefix(prefix) {
    if(!_storageIsEnable) {
      return 0;
    }
    const keys = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keys.push(key);
      }
    }
    for (const key of keys) {
      window.localStorage.removeItem(key);
    }
    return keys.length;
  }

}
//
// const handler = {
//   get: function(target, name) {
//     if(_storageIsEnable) {
//       return window.localStorage[name];
//     }
//     return undefined;
//   }
// };
// export const FcmLocalStorage = new Proxy(new _FcmLocalStorage(), handler);
export const FcmLocalStorage = new _FcmLocalStorage();

export default FcmLocalStorage;



